// «Обучение» (services/onboarding.js): progress, ticks, the welcome flag.
import { useEffect } from 'react';
import { api } from '../documents/docApi';

let cached = null; // { at, promise } — the menu, card and welcome share one request
const listeners = new Set();

export function getProgress({ fresh = false } = {}) {
  if (fresh || !cached || Date.now() - cached.at > 60000) {
    const promise = api('/api/onboarding').catch((e) => {
      cached = null;
      throw e;
    });
    cached = { at: Date.now(), promise };
  }
  return cached.promise;
}

function publish(p) {
  cached = { at: Date.now(), promise: Promise.resolve(p) };
  listeners.forEach((fn) => fn(p));
  return p;
}

// re-render when someone else changed the progress
export function onProgress(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export const markLesson = (key, how = 'self') =>
  api('/api/onboarding/mark', { method: 'POST', body: { key, how } }).then(
    publish
  );
export const unmarkLesson = (key) =>
  api('/api/onboarding/unmark', { method: 'POST', body: { key } }).then(
    publish
  );
export const setLearnFlags = (body) =>
  api('/api/onboarding/flags', { method: 'POST', body }).then(publish);
export const getTeam = () => api('/api/onboarding/team');
export const getExamples = () => api('/api/onboarding/examples');

// a page / feature that teaches a lesson by being used: tick it once per session
const sent = new Set();
export function learnEvent(key, how = 'event') {
  if (sent.has(key)) return;
  sent.add(key);
  markLesson(key, how).catch(() => sent.delete(key));
}

// pages: useLearnVisit('calendar')
export function useLearnVisit(key) {
  useEffect(() => {
    learnEvent(key, 'visit');
  }, [key]);
}
